module.exports = __webpack_public_path__ + "static/media/pla_wor_on_foo.3d6d696e.png";